<template>
  <admin-wrapper
    title-translation-path="admin.zdmFailureReportTitle"
    :has-buttons="false"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
  >
    <template #greyTabs.input>
      <grey-tabs v-model="tab" :tabs="tabs" has-border cols="auto">
        <v-tab-item>
          <failure-email-tab />
        </v-tab-item>
        <v-tab-item>
          <admin-input-row translation-path="admin.zdmFailureDictsTitle" name="dicts" align="baseline">
            <template #dicts.input>
              <ZDMFailureDictionaryList />
            </template>
          </admin-input-row>
        </v-tab-item>
      </grey-tabs>
    </template>
  </admin-wrapper>
</template>

<script>
import { get } from 'vuex-pathify';

import AdminInputRow from '@/components/AdminInputRow';
import AdminWrapper from '@/components/AdminWrapper';
import GreyTabs from '@/components/GreyTabs';
import ZDMFailureDictionaryList from '@/components/ZDMFailureDictionaryList';
import FailureEmailTab from '@/components/FailureEmailTab';

export default {
  name: 'ZDMFailureReportAdmin',
  components: {
    FailureEmailTab,
    ZDMFailureDictionaryList,
    GreyTabs,
    AdminWrapper,
    AdminInputRow,
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    isModuleEnabled: get('admin/settingsValues@zdm_failures_report_module_enabled'),
    tabs() {
      return [
        { name: this.$i18n.t('admin.emailSendTabName') },
        {
          name: this.$i18n.t('admin.zdmFailuresDescriptionsDictsTabName'),
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'zdm_failures_report_module_enabled',
        translationPath: 'admin.zdmFailureReportTitle',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.zdmFailureReportTitle') }),
      };
    },
    inputs() {
      return [
        {
          name: 'greyTabs',
          hasSuffix: false,
          isCustom: true,
          isNamedSlot: false,
        },
      ];
    },
  },
};
</script>

<style scoped></style>
